<p-toast></p-toast>
<div class="sanction-letter-container">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card mt-2" id="printableArea">
            <div class="print border bold" style="margin-top: 1px; text-align: center">
                <div class="flex justify-content-center">
                    <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                        class="mr-2 mt-1">
                </div>
                <div class="mt-3 headings">
                    <strong>
                        {{'SANCTION_LETTER_HEADER'| translate}}
                    </strong>
                    <br>
                    <strong>{{'HARYANA'| translate}}  </strong><br>
                    <strong>
                        {{'FINANCIAL_YEAR'| translate}} {{ '2025-26' }}
                    </strong>
                </div>
            </div>

            <div class="header my-3 mx-2">{{'SANCTION_LETTER_CONTENT'| translate}}
               <b>{{ sanctionLetterData?.FarmerName }}</b> {{'S/O'| translate}}<b>{{
                    sanctionLetterData?.FatherName }}</b>{{'VILLAGE'| translate}} <b>{{ sanctionLetterData?.Village }}</b> {{'DISTRICT'| translate}}
                <b>{{ sanctionLetterData?.District }} </b> {{'SANCTION_IS_HEREBY_ACCORDED_WITH_FOLLOWING_DETAILS'| translate}}
            </div>

            <!-- <div class="p-fluid p-formgrid grid table" *ngIf="!isPrintClicked">
                <div class="field col-12">
                    <p-table #appVerificationTable [value]="sanctionLetterDataForTable" [paginator]="false"
                        [rowHover]="true" dataKey="appID" [showCurrentPageReport]="false" [scrollable]="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    Application ID
                                </th>
                                <th>
                                    Area (Acre/hectare)
                                </th>
                                <th>
                                    Khasra No./ killa No.
                                </th>
                                <th>
                                    Crop
                                </th>
                                <th>
                                    Spacing (Mts)
                                </th>
                                <th>
                                    Type of MIS
                                </th>
                                <th>
                                    *Estimated Cost Of Systems (Rs)
                                </th>
                                <th>
                                    Estimated Farmer Share (Rs)
                                </th>
                                <th>
                                    Subsidy Share as per Scheme (Rs)
                                </th>
                                <th>
                                    Farmer Type (Small/Marginal/Others)
                                </th>
                                <th>
                                    Category (SC/ST/OBC/GEN)
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td>{{ product?.AppID }}</td>
                                <td>{{ product?.Area}}</td>
                                <td>{{ product?.KhasraAndKillaNo }}</td>

                                <td>{{ product?.crop }}</td>
                                <td>{{ product?.Spacing }}</td>
                                <td>{{ product?.TypeOfMIS }}</td>
                                <td>{{ product?.EstimatedCost }}</td>
                                <td>{{ product?.EstimatedFarmerShare }}</td>
                                <td>{{ product?.SubsidyShare }}</td>
                                <td>{{ product?.FarmerType }}</td>
                                <td>{{ product?.Category }}</td>

                            </tr>
                        </ng-template>

                        <ng-template pTemplate="summary">
                            <div class="flex align-items-center justify-content-between">
                                Total Share Amount of a Farmer is: {{ sanctionLetterData?.EstimatedFarmerShare }}
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </div> -->

            <div class="consent-form" >
                <div class="table">
                    <table>
                        <tr *ngFor="let product of sanctionLetterDataForTable">
                            <td>
                                <p class="bold">{{'APPLICATION_ID'| translate}}</p>
                                <p>{{ product?.AppID}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'AREA_IN_ACRE'| translate}}</p>
                                <p>{{ product?.Area}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'KHASRA_NO'| translate}}</p>
                                <p>{{ product?.KhasraAndKillaNo}}</p>
                            </td>
                        </tr>
                        <tr *ngFor="let product of sanctionLetterDataForTable">
                            <td>
                                <p class="bold">{{'CROP'| translate}}</p>
                                <p>{{ product?.CropName}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'SPACING'| translate}}</p>
                                <p>{{ product?.Spacing}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'TYPE_OF_MIS'| translate}}</p>
                                <p>{{ product?.TypeOfMIS}}</p>
                            </td>
                        </tr>
                        <tr *ngFor="let product of sanctionLetterDataForTable">
                            <td>
                                <p class="bold">{{'ESTIMATED_COST_OF_SYSTEMS'| translate}}</p>
                                <p>{{ product?.EstimatedCost}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'ESTIMATED_FARMER_SHARE'| translate}}</p>
                                <p>{{ product?.EstimatedFarmerShare}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'SUBSIDY_SHARE_AS_PER_SCHEME'| translate}}</p>
                                <p>{{ product?.SubsidyShare}}</p>
                            </td>
                        </tr>
                        <tr *ngFor="let product of sanctionLetterDataForTable">
                            <td>
                                <p class="bold">{{'FARMER_TYPE'| translate}}</p>
                                <p>{{ product?.FarmerType}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'CATEGORY'| translate}}</p>
                                <p>{{ product?.Category}}</p>
                            </td>
                        </tr>
                    </table>
                    <p class="bold mt-2">{{'AMOUNT_OF_FARMER_SHARE'| translate}}: {{ sanctionLetterData?.EstimatedFarmerShare }} </p>
                </div>
            </div>


            <div class="details mt-3">
                <div class="flex justify-content-center bold mb-1">{{'BANK_ACCOUNT_DETAILS'| translate}}</div>

                <div class="information">
                    <p>{{'NAME_OF_FARMER_AS_IN_BANK_ACCOUNT'| translate}}: {{ sanctionLetterData?.NameOfFarmerAsOnBankAcc }}</p>
                    <p>{{'NAME_OF_BANK'| translate}}: {{ sanctionLetterData?.NameOfBank }}</p>
                    <p>{{'IFSC_CODE'| translate}}: {{ sanctionLetterData?.IFSCCode }}</p>
                    <p>{{'ACCOUNT_NUMBER'| translate}}: {{ sanctionLetterData?.AccountNo }}</p>
                    <p>{{'BRANCH_NAME'| translate}}: {{ sanctionLetterData?.BranchName }}</p>
                </div>

                <div class="letter mt-3">
                    <p>To</p>
                    <div class="mx-3">
                        <p>{{'SRI/SMT'| translate}}, <b>{{ sanctionLetterData?.FarmerName }}</b>{{'S/O'| translate}}  <b>{{ sanctionLetterData?.FatherName
                                }}</b>{{'VILLAGE'| translate}} <b>{{ sanctionLetterData?.Village }}</b>{{'DISTRICT'| translate}}  <b>{{
                                sanctionLetterData?.District }}</b></p>
                        <p>{{'REGISTERED_MANUFACTURER/SUPPLIER.M/S'| translate}} <b>{{ sanctionLetterData?.VendorName }}</b></p>
                        <p>{{'DISTRICT_OFFICER_INCHARGE_OF_MI'| translate}} <b>{{ sanctionLetterData?.XENName }}</b><b>(XEN {{ sanctionLetterData?.XENDistrict }})</b></p>
                    </div>
                </div>
            </div>
            <div class="note mt-5">
                <p>{{'SANCTION_LETTER_NOTE_PART1'| translate}}<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{'SANCTION_LETTER_NOTE_PART2'| translate}} 
                </p>
            </div>
        </div>
        <div class="flex justify-content-around mt-5">
            <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT'| translate}}"
                (click)="onPrint('printableArea')"></button>
        </div>
    </p-card>
</div>